export const toTitleCase = (str: string | null) => (
  str ? 
    str.toLowerCase()
      .replace(/(^\w|\s\w)/g, (firstLetter: string) => firstLetter.toUpperCase()) :
    ''
)
